import { api } from './client';
import type { AdminOverview } from '@/types';

export function getAdminOverview(): Promise<AdminOverview> {
  return api<AdminOverview>('/api/admin/overview');
}
